var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 17.5h14a.75.75 0 0 0 0-1.5h-14a.75.75 0 0 0 0 1.5m0-5h14a.75.75 0 0 0 0-1.5h-14a.75.75 0 0 0 0 1.5m0-5h14a.75.75 0 0 0 0-1.5h-14a.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })));
};
export default SvgHamburgerMenu;